export default __webpack_public_path__ + "static/media/IMG_3063.4fe41a04.jpeg";